export enum CacheKeys {
  GUEST_ORDER_COMPLETED = "GUEST_ORDER_COMPLETED",
  RECENT_ORDERS = "RECENT_ORDERS",
  SIGNAL_R_TOKEN = "SIGNAL_R_TOKEN",
}
